function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.678.273l-1.66 1.516 5.672 5.13H.43V9.08h12.26l-5.673 5.13 1.66 1.517L16.659 8z",
  fill: "#FFF",
  fillRule: "evenodd"
});

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDE3IDE2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik04LjY3OC4yNzNsLTEuNjYgMS41MTYgNS42NzIgNS4xM0guNDNWOS4wOGgxMi4yNmwtNS42NzMgNS4xMyAxLjY2IDEuNTE3TDE2LjY1OSA4eiIgZmlsbD0iI0ZGRiIgZmlsbC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPgo=";
export { SvgArrowRight as ReactComponent };